module.exports = __webpack_public_path__ + "img/dash-flex.9edeea69.svg";